import { useMutation, useQueryClient } from '@tanstack/react-query';

import { BundleItemOptionCreate } from '~/components/Cruises/pages/Bundles/types';

import bundlesService from '~/services/cruises/BundlesService';

import { bundleQueryKeys } from './bundleQueryKeys';

interface CreateOptionParams {
  bundleId: string;
  itemId: string;
  data: BundleItemOptionCreate;
}

interface DeleteOptionParams {
  bundleId: string;
  itemId: string;
  optionId: string;
}

export function useCreateBundleItemOption() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ bundleId, itemId, data }: CreateOptionParams) => {
      return await bundlesService.createOption(bundleId, itemId, data);
    },
    onSuccess: (_result, variables) => {
      queryClient.invalidateQueries({ queryKey: bundleQueryKeys.options(variables.bundleId, variables.itemId) });
    },
  });
}

export function useDeleteBundleItemOption() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ bundleId, itemId, optionId }: DeleteOptionParams) => {
      return await bundlesService.deleteOption(bundleId, itemId, optionId);
    },
    onSuccess: (_result, variables) => {
      queryClient.invalidateQueries({ queryKey: bundleQueryKeys.options(variables.bundleId, variables.itemId) });
    },
  });
}
